export default () => ({
    items: [],
    headings: [],
    onScroll() {
        const scrollPosition = window.scrollY + window.innerHeight/3*2;
        this.items.forEach(item => {
            if (item.element) {
                const headingTop = item.element.offsetTop;
                if (scrollPosition >= headingTop) {
                    item.active = true;
                } else {
                    item.active = false;
                }
            }
        });
    },
    scrollTo(item) {
        if (item.element) {
            const elementRect = item.element.getBoundingClientRect();
            const elementTop = elementRect.top + window.scrollY;
            const viewportHeight = window.innerHeight;
            const elementHeight = elementRect.height;
            const scrollPosition = elementTop - (viewportHeight / 2) + (elementHeight / 2);
            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            });
        }
    },
    init() {
        this.items = JSON.parse(this.$refs.json.innerHTML);
        this.items.forEach((item) => {
            item.element = document.getElementById(item.id);
            item.active = false;
        });
        window.addEventListener('scroll', this.onScroll.bind(this));
        this.onScroll();
    }
});